//
//
//
//
//
//

import http from "@/javascript/http";
import store from "@/store";
import mapUtil from "@/javascript/mapUtil";

export default {
  methods: {
    getLocationFun: (res) => {
      res.address = ""
        .concat(res.addressComponent.district)
        .concat(res.addressComponent.street)
        .concat(res.addressComponent.streetNumber);
      store.dispatch("setLocation", res);
    },
    getLocation: function () {
      mapUtil.locate(
        (res) => this.getLocationFun(res),
        (res) => this.getLocationFun(res)
      );
    },
  },
};
